import axios from 'smg/axios';
import { HandleRequestError } from 'smg/errors';

import Big from 'big.js';
import Modal from 'smg/modal';
import * as models from 'smg/models';
import { G } from 'smg/querystring';
import * as template from 'smg/template';
import { DollarFormat } from 'smg/util';
import * as address from '../address';
import { DrawCartItemPreviewFromOrder } from '../components/cart-item-preview';

if (document.body.id === 'order-success') {
    void main();
}

declare interface myWindow extends Window {
    googleReviews: string;
    readonly apiRoot: string;
}
declare const window: myWindow;

declare interface orderResp {
    order: models.Order;
}

async function main() {
    const $spinner = document.querySelector('#order-success-spinner') as HTMLElement;
    const $notFound = document.querySelector('#order-success-not-found') as HTMLElement;
    const $content = document.querySelector('#order-success-content') as HTMLElement;

    const key = G().Get('id');

    const notFound = () => {
        $spinner.remove();
        $notFound.classList.remove('d-none');
    };

    if (!key) {
        notFound();
        return;
    }

    const order = await axios.get<orderResp>(`/orders/${key}`).
        then(resp => resp.data.order).
        catch(err => {
            HandleRequestError(err);
            notFound();
            throw err;
        });

    if (window.googleReviews) {
        const m = new Modal({
            title: 'Loved your purchase?',
            size: 'modal-sm',
            text: 'We\'d be thrilled to hear your thoughts! Leave us a Google review and let us know. (This will open a new tab)',
            confirmText: 'Leave a Review!',
            cancelText: 'No Thank You',
            onSubmit: () => window.open(window.googleReviews, '_blank'),

            headerLevel: 'h2',
            confirmButtonClass: 'btn btn-primary m-0',
            cancelButtonClass: 'btn btn-outline-primary m-0',
            appendBodyClass: 'p-4 px-md-20',
            appendClassBySelector: {
                '.modal-footer': 'justify-content-center flex-row-reverse gap-4',
                '.modal-body': 'change-quantity-request',
            },
        });

        const $modalFooter = m.Element.querySelector('.modal-footer') as HTMLElement;
        const googleReviewIcon = template.Clone('#google-review-logo-template').firstElementChild as HTMLElement;

        $modalFooter?.insertBefore(googleReviewIcon, $modalFooter.firstElementChild);
    }

    const promises: Promise<unknown>[] = [];

    const $shippingCard = document.querySelector('#order-success-shipping-card') as HTMLElement;
    if (order.orderShippingOptions?.[0].shippingOption) {
        const shippingOption = order.orderShippingOptions[0].shippingOption;
        const $address = document.querySelector('address') as HTMLElement;

        promises.push(
            address.Draw(shippingOption, shippingOption.phone, shippingOption.email).then($ => {
                $address.appendChild($);
            }));

        $shippingCard.classList.remove('d-none');
    }

    const $invoiceNumber = document.querySelector('#order-success-number') as HTMLElement;
    $invoiceNumber.textContent = String(order.invoiceNumber);

    const $orderPreview = document.querySelector('#your-cart-items') as HTMLElement;
    DrawCartItemPreviewFromOrder($orderPreview, order);

    const $total = document.querySelector('#order-success-total') as HTMLElement;
    $total.textContent = DollarFormat(order.total ?? 0);

    const hasPo = (order: models.Order) => {
        if (order.orderPayments) {
            for (const orderPayment of order.orderPayments) {
                if (orderPayment.paymentOption) {
                    if (orderPayment.paymentOption.paymentOptionTypeID === models.PaymentOptionTypeID.PAYMENT_OPTION_TYPE_PO) {
                        return true;
                    }
                }
            }
            return false;
        }
    };

    const balance = Big(order.balance || 0);
    if (!hasPo(order) && balance.gt('0.05')) {
        const $balanceNotice = document.querySelector('#order-success-balance-notice') as HTMLElement;
        $balanceNotice.classList.remove('d-none');
    }

    if (G().Get('paypal') === 'error') {
        const $paypalError = document.querySelector('#order-success-paypal-error') as HTMLElement;
        $paypalError.classList.remove('d-none');
    }

    await Promise.all(promises);

    $spinner.remove();
    $content.classList.remove('d-none');
}
